import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import * as Actions from './store/actions';
import * as NotificationActions from '../notification/store/actions';
import * as UserActions from '../../../auth/store/actions';
import {
    Card, CardContent, Divider, IconButton, Button, Icon, Typography, Grid, List, ListItem, ListItemIcon, ListItemText, Popover,
    DialogTitle, DialogContent, DialogActions, Dialog
} from '@material-ui/core';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { Tooltip } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import SelfPacedCourseWeeklyView from './widgets/SelfPacedCourseWeeklyView';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import SelfPacedGradebookStudent from './CourseDashboard/SelfPacedGradebookStudent';

const localizer = BigCalendar.momentLocalizer(moment);
const styles = theme => ({
    root: {
        padding: '16px',
        '& .rbc-event-label': {
            display: 'none',
        },
        '& .rbc-row-segment': {
            padding: '0 4px 4px 4px'
        },
        '& .rbc-timeslot-group': {
            minHeight: '60px'
        },
        '& .cell': {
            padding: '0px',
            fontSize: '12px'
        },
        '& .assetblock': {
            display: 'inherit'
        }
    },
    popover: {
        pointerEvents: 'none',
    },
})

class ScheduledCourseDashboard extends Component {
    constructor(props) {
        super(props);
        const ccc_id = this.props.match.params.company_calendar_course_id;
        const student_id = this.props.auth.user.data.role_info.link_id;
        const auth_id = this.props.auth.user.data.auth_id;
        const unscheduled = this.props.match.params.unscheduled;

        this.state = {
            ...this.state,
            ccc_id: ccc_id,
            student_id: student_id,
            unscheduled
        }
        this.props.getCourseData(ccc_id, student_id, unscheduled, auth_id)
        // this.props.updateUserRoles(auth_id)
    }

    state = {
        menuOpenEvent: null,
        popoverOpen: false,
        anchorEl: null,
        notificationDialogOpen: false,
        notification: {}
    }

    componentDidUpdate = (prevProps, prevState) => {
        const ccc_id = this.props.match.params.company_calendar_course_id;
        const unscheduled = this.props.match.params.unscheduled;
        const auth_id = this.props.auth.user.data.auth_id;
        if (
            !_.isEqual(ccc_id, prevProps.match.params.company_calendar_course_id)
        ) {
            this.props.updatePageLoaded(false)
            this.setState({
                ...this.state,
                ccc_id: ccc_id,
                unscheduled
            })
            this.props.getCourseData(ccc_id, this.state.student_id, unscheduled, auth_id)
        }
    }

    handleEventSelect = (event) => {
        if (event.EventType === 'Assignment') {
            return this.props.history.push('/assignment/student/' + event.company_calendar_event_id)
        }
        return this.props.history.push('/quiz/student/' + event.company_calendar_event_id)
    }

    handlePopoverOpen = (e, event) => {
        this.setState({ popoverOpen: true, menuOpenEvent: event.company_calendar_event_id, anchorEl: e.target })
    }

    handlePopoverClose = () => {
        this.setState({ popoverOpen: false, menuOpenEvent: null, anchorEl: null })
    }


    handleNotificationDialogClose = (notification) => {
        this.setState({
            notificationDialogOpen: false,
            notification: {}
        })
        this.props.resolveNotification(notification.notification_relation_id)
    }

    render() {
        const { course, theme, events, classes, gradebook } = this.props;
        if (!this.props.loaded) {
            return <div>...loading</div>
        }
        const notificationDialog = (notification) => {
            return (
                <Dialog
                    open={this.state.notificationDialogOpen}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    onBackdropClick={() => this.setState({ notification: {}, notificationDialogOpen: false })}
                >
                    <DialogTitle>{notification.NotificationHeader}: {moment(notification.NotificationDate).format('MM-DD-YYYY')}</DialogTitle>
                    <DialogContent>
                        <div>{notification.NotificationContent}</div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.handleNotificationDialogClose(notification)}>
                            Dismiss
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        }

        const getPopoverIcon = (event) => {
            if (moment(event.StartTime) < moment()) {
                if (event.Submitted) {
                    return (
                        <div className='float-right'>
                            <Tooltip
                                title={
                                    <React.Fragment>
                                        <div>Submitted: {moment(event.Submitted).format('MM-DD-YYYY')}</div>
                                        <div>Grade: {event.IsGraded ? Number(event.Score).toFixed(1) : 'waiting'}</div>
                                    </React.Fragment>}
                                enterDelay={500}
                            >
                                <div className="flex items-center">
                                    <CheckIcon />
                                </div>
                            </Tooltip>
                        </div>
                    )
                }
                return (
                    <div className='float-right'>
                        <Icon>warning</Icon>
                    </div>
                )
            }
            else {
                return (null)
            }
        }

        const customComponent = ({ event }) => (
            <div style={{ borderTop: 'white' }} key={event.id}>
                {
                    event.Unscheduled === 0 ?
                        <div className='float-left' style={{ paddingTop: '2px' }}>
                            <div style={{ fontSize: '10px' }}>
                                {moment(event.start).format('h:mm A')} - {moment(event.end).format('h:mm A')}
                            </div>
                            <div>
                                {event.title}
                            </div>
                        </div> :
                        <div className='float-left' style={{ paddingTop: '2px' }}>{event.title}</div>
                }

                {getPopoverIcon(event)}
            </div>
        )

        const eventStyleGetter = (event, start, end, isSelected) => {

            let borderString = '';
            if (event.Submitted) {
                borderString = '2px solid green'
            }
            else if (!event.Submitted && moment() > moment(event.start)) {
                borderString = '2px solid red'
            }

            let style = {
                backgroundColor: event.Color,
                color: this.props.theme.palette.getContrastText(event.Color),
                // border: borderString
            }

            return { style: style }
        }
        return (
            <div className={classes.root}>
                {notificationDialog(this.state.notification)}
                <Grid container spacing={8}>
                    <Grid item xs={12}>
                        {this.props.match.params.unscheduled === '1' ?
                            <SelfPacedCourseWeeklyView
                                events={events}
                                history={this.props.history}
                                unavailableToClick={
                                    course.nextSelfPacedEvent.length > 0 ? gradebook.outstandingEvents.map(e => e.company_calendar_event_id).filter(e => e !== course.nextSelfPacedEvent[0].company_calendar_event_id): []
                                }
                            />
                            :
                            <BigCalendar
                                components={{ event: customComponent }}
                                defaultView='work_week'
                                views={['work_week']}
                                localizer={localizer}
                                events={events}
                                toolbar={true}
                                step={60}
                                min={new Date(moment().startOf('day').add(6, 'hours'))}
                                max={new Date(moment().startOf('day').add(18, 'hours'))}
                                eventPropGetter={(eventStyleGetter)}
                                onSelectEvent={(e) => this.handleEventSelect(e)}
                                popup
                            />
                        }

                    </Grid>
                    <Grid item xs={6}>
                        <Card elevation={1} justify="center" className="flex flex-col min-h-256" style={{ height: '400px' }}>
                            <div
                                className="flex text-center h-64"
                                style={{
                                    background: "#3c4252",
                                    color: theme.palette.getContrastText("#3c4252"),
                                    display: 'block',
                                    fontSize: '20px'
                                }}
                            >
                                <div>Gradebook</div>
                            </div>
                            <CardContent 
                                className=""
                                style={{ overflowY: 'auto' }}
                            >
                                {this.props.course.Unscheduled === 0 ?
                                    <Table style={{ margin: '0px', padding: '0xp' }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className='cell'>Event</TableCell>
                                                <TableCell className='cell'>Event Date</TableCell>
                                                <TableCell className='cell'>Score</TableCell>
                                                <TableCell className='cell'></TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {events.filter(e => e.Submitted)
                                                .map(event => {
                                                    const scoreColumn = (eventRow) => {
                                                        if (eventRow.IsGraded === 1) {
                                                            return (
                                                                <span>{Number(event.Score).toFixed(1)} / {Number(event.TotalScore).toFixed(1)}</span>
                                                            )
                                                        }
                                                        else {
                                                            return (
                                                                <span>Waiting</span>
                                                            )
                                                        }
                                                    }
                                                    return (
                                                        <TableRow key={event.company_calendar_event_id}>
                                                            <TableCell className='cell'>{event.EventName}</TableCell>
                                                            <TableCell className='cell'>{moment(event.EventDate).format('MM-DD-YYYY')}</TableCell>
                                                            <TableCell className='cell'>{scoreColumn(event)}</TableCell>
                                                            <TableCell className='cell'>
                                                                <IconButton
                                                                    onClick={() => this.props.history.push('/' + event.EventType.toLowerCase() + '/student/' + event.company_calendar_event_id)}
                                                                    style={{ padding: '0px' }}
                                                                >
                                                                    <Icon>search</Icon>
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>

                                                    )
                                                })}
                                            <TableRow>
                                                <TableCell className='cell'><a href={'/gradebook/student/event_list/' + this.props.course.company_calendar_course_id}>See All</a></TableCell>
                                                <TableCell className='cell'></TableCell>
                                                <TableCell className='cell'></TableCell>
                                                <TableCell className='cell'></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    :
                                    <SelfPacedGradebookStudent events={gradebook} course={this.props.course} history={this.props.history} courseEvents={events} />
                                }
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={6}>
                        <Card elevation={1} className="flex flex-col min-h-256" style={{ height: '400px' }}>
                            <div
                                className="flex text-center h-64"
                                style={{
                                    background: "#3c4252",
                                    color: theme.palette.getContrastText("#3c4252"),
                                    display: 'block',
                                    fontSize: '20px'
                                }}
                            >
                                {this.props.course.Unscheduled === 0 ? 'Outstanding Assignments' : 'Next Assignment'}
                            </div>
                            <CardContent 
                                className=""
                                style={{ overflowY: 'auto' }}
                            >
                                <Table style={{ margin: '0px', padding: '0xp' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='cell'>Event</TableCell>
                                            <TableCell className='cell'>Event Date</TableCell>
                                            <TableCell className='cell'>Total Points</TableCell>
                                            <TableCell className='cell'></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {course.Unscheduled === 0 ?
                                            gradebook.outstandingEvents
                                                .map(event => {
                                                    return (
                                                        <TableRow key={event.company_calendar_event_id}>
                                                            <TableCell className='cell'>{event.EventName}</TableCell>
                                                            <TableCell className='cell'>{event.EventDate}</TableCell>
                                                            <TableCell className='cell'>{Number(event.EventTotalScore).toFixed(1)}</TableCell>
                                                            <TableCell className='cell'>
                                                                <IconButton
                                                                    onClick={() => this.props.history.push('/' + event.EventType.toLowerCase() + '/student/' + event.company_calendar_event_id)}
                                                                    style={{ padding: '0px' }}
                                                                >
                                                                    <Icon>create</Icon>
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                })
                                            :
                                            course.nextSelfPacedEvent.map(event => {
                                                return (
                                                    <TableRow key={event.company_calendar_event_id}>
                                                        <TableCell className='cell'>{event.EventName}</TableCell>
                                                        <TableCell className='cell'></TableCell>
                                                        <TableCell className='cell'>{Number(event.EventTotalScore).toFixed(1)}</TableCell>
                                                        <TableCell className='cell'>
                                                            <IconButton
                                                                onClick={() => this.props.history.push('/' + event.EventType + '/student/' + event.company_calendar_event_id)}
                                                                style={{ padding: '0px' }}
                                                            >
                                                                <Icon>create</Icon>
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }

                                    </TableBody>
                                </Table>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCourseInfo: Actions.getCourseInfo,
        getCourseEvents: Actions.getCourseEvents,
        getCourseGradebook: Actions.getCourseGradebook,
        getCourseAssets: Actions.getCourseAssets,
        getCourseNotifications: Actions.getCourseNotifications,
        getCourseData: Actions.getCourseData,
        updatePageLoaded: Actions.updatePageLoaded,
        resolveNotification: NotificationActions.resolveNotification,
        updateUserRoles: UserActions.updateUserRoles
    }, dispatch);
}

function mapStateToProps({ auth, dashboardApp }) {
    return {
        auth,
        course: dashboardApp.course.course,
        events: dashboardApp.course.events,
        gradebook: dashboardApp.course.gradebook,
        loaded: dashboardApp.course.loaded
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ScheduledCourseDashboard)));


// WEBPACK FOOTER //
// src/main/content/dashboard/StudentCourseDashboard.js